import { render, staticRenderFns } from "./ClientProfile.vue?vue&type=template&id=65553f4e&"
import script from "./ClientProfile.vue?vue&type=script&lang=js&"
export * from "./ClientProfile.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfile.vue?vue&type=style&index=0&id=65553f4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports